import React from 'react';

/* Form controls shared by the Settings tabs. */

const CONTROL = [
  'w-full min-w-0 px-3 py-2 rounded-[10px] border border-black/[0.10]',
  'text-[13px] leading-[1.4] placeholder:text-lb-ghost outline-none transition-colors',
  'focus:border-lb-green-accent focus-visible:ring-2 focus-visible:ring-[#6fb96a]/30',
].join(' ');

export const Field = ({ id, label, hint, className = '', children }) => (
  <div className={['flex flex-col gap-1.5 min-w-0', className].filter(Boolean).join(' ')}>
    <label htmlFor={id} className="text-[12px] font-semibold leading-none text-lb-body">
      {label}
    </label>
    {children}
    {hint && (
      <p id={`${id}-hint`} className="m-0 text-[12px] leading-[1.45] text-lb-muted">
        {hint}
      </p>
    )}
  </div>
);

export const TextInput = React.forwardRef(({ readOnly = false, className = '', ...rest }, ref) => (
  <input
    ref={ref}
    readOnly={readOnly}
    {...rest}
    className={[
      CONTROL,
      readOnly ? 'bg-lb-surface-readonly text-lb-muted' : 'bg-[#FAFAF7] text-lb-ink',
      className,
    ].filter(Boolean).join(' ')}
  />
));
TextInput.displayName = 'TextInput';

export const SelectInput = ({ className = '', children, ...rest }) => (
  <select
    {...rest}
    className={[
      CONTROL,
      'bg-[#FAFAF7] text-lb-ink font-semibold cursor-pointer disabled:cursor-not-allowed disabled:opacity-60',
      className,
    ].filter(Boolean).join(' ')}
  >
    {children}
  </select>
);
